import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import CommonLayout from 'components/layout/common'
import { withI18next } from 'lib/i18n/withI18next'
import TTBHome from 'components/ttb-home'
import BasePage from '../base'
import { PAGE_NAME } from '../const'

class TTBHomePage extends BasePage {
  static getInitialProps({ store, req, res, isServer }) {
    if (isServer) {
      BasePage.loadInitialContentFromServer({ req, res, store })
    } else {
      BasePage.loadInitialContentFromClient(req, res, store)
    }
    return {}
  }

  render() {
    return (
      <CommonLayout pageName={PAGE_NAME.ttbHome}>
        <TTBHome />
      </CommonLayout>
    )
  }
}

TTBHomePage.propTypes = {
  internationalization: PropTypes.shape({
    country: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
  }).isRequired,
  isPhone: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
}

const Extended = withI18next()(TTBHomePage)

export default connect((state) => ({
  internationalization: state.internationalization,
  isPhone: state.device.isPhone,
}))(Extended)
